import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import PageHeader from '#components/m/PageHeader'
import Headline from '#components/a/Headline'
import Button from '#components/a/Button'
import NotificationList from '#components/m/Notification/NotificationList'
import NotificationCreateModal from '#components/o/Notification/NotificationCreateModal'

class AllNotifications extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      itemsPerPage: 50,
      page: 1,
    }
  }

  componentDidMount() {
    const {loadNotifications} = this.props
    const {itemsPerPage, page} = this.state
    loadNotifications({resultsPerPage: itemsPerPage, pageNumber: page})
  }

  componentDidUpdate(prevProps) {
    const {allNotifications} = this.props
    if (prevProps.allNotifications && allNotifications && prevProps.allNotifications.length > allNotifications.length) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        page: 1,
      })
    }
  }

  loadNextPage = () => {
    const {loadNotifications} = this.props
    const {itemsPerPage, page} = this.state
    loadNotifications({resultsPerPage: itemsPerPage, pageNumber: page + 1})
    this.setState({
      page: page + 1,
    })
  }

  onReadAll = () => {
    const {readAll} = this.props
    readAll({resultCount: this.itemCount()})
  }

  onReadOne = ({notificationId}) => {
    const {readOne} = this.props
    readOne({notificationId, resultCount: this.itemCount()})
  }

  itemCount = () => {
    const {itemsPerPage, page} = this.state
    return itemsPerPage * page
  }

  render() {
    const {permissions, allNotifications, markAsUnread} = this.props
    return (
      <div className="allNotifications">
        <div className="allNotifications__header">
          <PageHeader
            headline={<Headline importance={2} modifier="section" text={i18n.t('notification')} />}
            button={
              <div>
                <button className="markAllAsRead" type="button" onClick={this.onReadAll}>
                  {i18n.t('notification_dismissAll')}
                </button>
                {permissions.notifications.create && (
                  <NotificationCreateModal
                    trigger={
                      <Button text={i18n.t('notification_sendNotification')} event={() => {}} variant="primary" />
                    }
                  />
                )}
              </div>
            }
          />
        </div>
        <div className="allNotifications__content">
          <div className="allNotifications__content--scroller">
            <NotificationList
              maxItemCount={this.itemCount()}
              markOneAsRead={this.onReadOne}
              markAsUnread={markAsUnread}
            />
            {allNotifications && allNotifications.length >= this.itemCount() && (
              <Button variant="secondary" event={this.loadNextPage} text={i18n.t('notification_load_more')} />
            )}
          </div>
        </div>
      </div>
    )
  }
}

AllNotifications.propTypes = {
  permissions: PropTypes.object,
  loadNotifications: PropTypes.func,
  readAll: PropTypes.func,
  readOne: PropTypes.func,
  markAsUnread: PropTypes.func,
  allNotifications: PropTypes.array,
}

export default AllNotifications
